import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children, title }) => (
  <div className="min-h-screen flex flex-col bg-[#f4f5f7]">
    <Header title={title} />
    <main className="flex-1 w-full">{children}</main>
    <Footer />
  </div>
);

export default Layout;
